import { render, staticRenderFns } from "./SMTicketsDetails.vue?vue&type=template&id=76cc3798&"
import script from "./SMTicketsDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./SMTicketsDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports